<template>
    <div>
        <br />
        <br />

        <!------------------------------------------------------------------------------------>
        <!-- foto and buttons -->
        <!------------------------------------------------------------------------------------>

        <div class="container-fluid foto mb-5">
            <div class="row">
                <!-- <div class="col-md-10 col offset-md-1 offset-0"> -->
                <div class="col-md-8 col offset-md-2 offset-0">
                    <br />
                    <p class="is-size-1 mb-2 text-white font-weight-bold text-shadow">Das Spiel mit den Worten</p>
                    <br />
                    <br />
                    <div class="row">
                        <div class="col btn-red fill font-weight-bold">
                            <router-link to="/woorden">
                                <p class="is-size-5 text-white my-3">Wörter</p>
                            </router-link>
                        </div>
                        <div class="col btn-blue fill font-weight-bold">
                            <router-link to="/praatplaten">
                                <p class="is-size-5 text-white my-3">Bilderkarten</p>
                            </router-link>
                        </div>
                        <!-- FASE-2 -->
                        <!-- <div class="col btn-green fill font-weight-bold">
							<router-link to="/muziek">
								<p class="is-size-5 text-white my-3">muziek</p>
							</router-link>
						</div>
						<div class="col btn-orange fill font-weight-bold">
							<router-link to="/werkvormen">
								<p class="is-size-5 text-white my-3">werkvormen</p>
							</router-link>
						</div> -->
                        <div class="col btn-purple fill font-weight-bold">
                            <router-link to="/meermateriaal">
                                <p class="is-size-5 text-white my-3">Mehr Material</p>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!------------------------------------------------------------------------------------>
        <!-- home text -->
        <!------------------------------------------------------------------------------------>
        <section>
            <div class="container">
                <div class="row">
                    <div class="col-md-8 offset-md-2 offset-sm-0 text-center">
                        <h1 class="font-weight-bold">Willkommen auf der Website „Plaudern mit Pim“!</h1>

                        <p>
                            „Plaudern mit Pim“ ist ein besonderes Projekt. Die Website richtet sich an niederländische
                            Grundschulen und Lehrkräfte, die ihren Schülerinnen und Schülern auf spielerische Weise die
                            deutsche Sprache näherbringen möchten. Die Materialien eignen sich ideal für den
                            Deutschunterricht mit jüngeren Kindern. Gleichzeitig lässt sich die Website auch
                            hervorragend im Deutschunterricht in Deutschland einsetzen – zum Beispiel in
                            Kindertagesstätten oder Schulen, für deutschsprachige oder anderssprachige Schülerinnen und
                            Schüler.
                        </p>
                        <p>
                            „Plaudern mit Pim“ basiert auf der niederländischen Website „Praten met Pim“, die in
                            Zusammenarbeit mit pädagogischen Fachkräften, Lehrkräften und Bildungsexperten in den
                            Niederlanden entwickelt wurde. Im Auftrag der Gemeinde Enschede entstanden Materialien für
                            Kinder im Kleinkind- und Vorschulalter, die gezielt den Wortschatz fördern. Sie bieten eine
                            solide sprachliche Grundlage für alle Kinder – und einen besonders intensiven Ansatz für
                            jene, die Unterstützung in ihrer Sprachentwicklung benötigen.
                        </p>

                        <p>
                            Die Themen von Pim sind für Kinder leicht wiederzuerkennen und nah an ihrer Lebenswelt. Bei
                            der Übersetzung von „Praten met Pim“ ins Deutsche wurde darauf geachtet, den Alltag und die
                            Lebensrealität von Kindern in Deutschland möglichst authentisch widerzuspiegeln. So erhalten
                            Kinder mit Pim einen spannenden Einblick über die Grenze hinweg.
                            Eines aber bleibt überall gleich: Lernen ist ein Kinderspiel!
                            Das bedeutet: spielen, spielen und noch mehr spielen! Sprache wird erlebt durch Fühlen,
                            Sehen, Hören und Spielen.
                        </p>
                        <p>
                            Gerne möchten wir Ihnen Pim und die dazugehörigen Materialien vorstellen.
                        </p>

                        <div class="mt-5">
                            <p class="small">
                                © Copyright {{ year }} Gemeente Enschede - version {{ packageVersion }}
                            </p>
                        </div>

                        <p class="small">
                            Das Material, die Bilder/Zeichnungen und das Konzept dürfen nur für Bildungszwecke verwendet
                            werden. Bei Fragen zum Material senden Sie bitte eine E-Mail an:
                            <span>
                                <a href="mailto:expertisecentrum@edl-euregio.nl">expertisecentrum@edl-euregio.nl</a>
                            </span>
                        </p>

                        <div class="row">
                            <div class="w-100">
                                <div data-v-bf15af1c="" class=" dots-bar dots-p"></div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col my-3">
                                <p class="text-red my-6 small">
                                    Das Projekt Euregionale Bildungskette (EDL) wird im Rahmen des Interreg VI-Programms
                                    Deutschland-Nederland durchgeführt und durch die Europäische Union, das MWIKE NRW
                                    und das MB Niedersachsen sowie die Provinzen Overijssel und Gelderland
                                    mitfinanziert.
                                </p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-3">
                                <img class="img-fluid" id="logo" src="../assets/MinisteriumWirtschaft.png">
                            </div>
                            <div class="col-3">
                                <img class="img-fluid" id="logo" src="../assets/Niedersachsische.png">
                            </div>
                            <div class="col-3">
                                <img class="img-fluid" id="logo" src="../assets/ProvincieOverijssel.png">
                            </div>
                            <div class="col-3">
                                <img class="img-fluid" id="logo" src="../assets/ProvincieGelderland.png">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import top from './Top.vue';

export default {
    data: () => ({
        packageVersion: process.env.PACKAGE_VERSION || '0',
        year: new Date().getFullYear(),
    }),

    components: {
        top,
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
    background: white;
}

h1 {
    font-size: 16px;
}

.foto {
    background-image: url('../assets/foto_home.jpg');
    background-color: white;
    background-position: center center;
    padding: 3rem 1.5rem;
}

.fill {
    background-size: 100% 100%;
}

.btn-red {
    background-image: url('../assets/btn-red.png');
}

.btn-blue {
    background-image: url('../assets/btn-blue.png');
}

.btn-green {
    background-image: url('../assets/btn-green.png');
}

.btn-purple {
    background-image: url('../assets/btn-purple.png');
    cursor: pointer;
}

.small {
    font-size: 0.9rem;
}

.text-shadow {
    text-shadow: gray 0.01em 0.01em 1em;
}

.dots-p {
    background-image: url('../assets/stippel_P.svg');
}

.dots-bar {
    height: 20px;
    background-repeat: repeat-x;
    background-size: 20px;
}

.text-red {
    color: #c42737;
}
</style>
